export const BLOCKED_CARRIERS_HEADERS = [
    {
        name: 'Blocked Carrier',
        value: 'name',
    },
    {
        name: 'Actions',
        value: 'actions',
        minWidth: 114,
        align: 'center',
    },
]
